import { composeIO } from 'react-compose-io'
import { historicoInadimplenciaIO } from './HistoricoInadimplencia.IO'
import { HistoricoInadimplenciaView } from './HistoricoInadimplencia.View'

export const HistoricoInadimplencia = composeIO(HistoricoInadimplenciaView, historicoInadimplenciaIO)
